import AppPageShell from "../components/AppPageShell";
import TeamMotivationHub from "../components/TeamMotivationHub";
import "../components/team-motivation.css";

export default function TeamMotivationPage() {
  return (
    <AppPageShell
      className="app-page--rating"
      title="Рейтинг"
      subtitle="XP, достижения и результаты сотрудников по всем проектам компании."
    >
      <TeamMotivationHub scope="team" />
    </AppPageShell>
  );
}
